//API_IMPORT_START ====
import { query_operation_log_list } from '@/api/mjstock-model';
//API_IMPORT_END
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model/mjstock/mjstock-operationlog-config';
import column_config from '@/components/page-model/mjstock/mjstock-operationlog-column-config';
import edit_config from '@/components/page-model/mjstock/mjstock-operationlog-edit-config';
import update_config from '@/components/page-model/mjstock/mjstock-operationlog-update-config';

import { reactive } from 'vue';

export default () => {
  const None = null;
  const True = true;
  const False = false;
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const { baseColumns } = column_config(current_org);
  const { edit_model_config, edit_model_config_options } = edit_config(current_org);
  const { update_model_config, update_model_config_options } = update_config(current_org);

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'rangepicker',
        name: 'create_time',
        label: '创建时间',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        valueFormat: 'YYYY-MM-DD HH:mm',
        showTime: true,
        placeholder: '请填写创建时间',
      },
      {
        type: 'input',
        name: 'api_url',
        label: '接口url',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写接口url',
      },
      {
        type: 'input',
        name: 'api_name',
        label: '接口名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写接口名称',
      },
      {
        type: 'input',
        name: 'person_name',
        label: '用户名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写用户名称',
      },
      {
        type: 'input',
        name: 'person_id',
        label: '用户id',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写用户id',
      },
      {
        type: 'input',
        name: 'level',
        label: '日志等级',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写日志等级',
      },
      {
        type: 'input',
        name: 'model_name',
        label: '表名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写表名称',
      },
      {
        type: 'input',
        name: 'model_id',
        label: '数据id',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        placeholder: '请填写数据id',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      create_time: null,
      api_url: null,
      api_name: null,
      person_name: null,
      person_id: null,
      level: null,
      model_name: null,
      model_id: null,
    }),
  };
  const search_options = {};

  const titleList = {
    title: '操作日志管理',
    addModalTitle: '新建操作日志',
    updateTitle: '修改操作日志',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_operation_log_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: null,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
